/**
 * 竞价列表页面权限
 */
export const TRADITION_AUCTION_LIST_PAGE_UUID =
  'ba286a2e-7bb4-4a1b-a0aa-bdbe71e1e330'

/**
 * 竞价会员管理权限 （邀请、审核、查看资质）
 */
export const TRADITION_AUCTION_BID_MEMBER_MANAGE_ACTION_UUID =
  '80621715-e524-42f9-9529-e60dca2b963a'
